/**
 * Small persistence helper for resuming the Plan Actions Tour across page
 * navigations. When a founder clicks "Open this page" mid-tour, we stash which
 * business + which action to resume on, so the tour can pick up where it left
 * off when they return to the plan.
 */
const KEY = "tlb:plan-actions:tour-resume:v1";
// Only auto-resume / show the chip for a short window so a long-abandoned tour
// doesn't nag the founder days later.
const MAX_AGE_MS = 60 * 60 * 1000; // 1 hour

export function writeTourResume(businessId, target) {
  if (typeof window === "undefined" || !businessId || !target) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ businessId, target, ts: Date.now() }));
  } catch {
    /* private mode — silent */
  }
}

export function readTourResume() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.businessId || !data?.target) return null;
    if (data.ts && Date.now() - data.ts > MAX_AGE_MS) {
      clearTourResume();
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearTourResume() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* private mode — silent */
  }
}
